import React from 'react';
import { AiOutlineSetting, AiOutlineUser } from "react-icons/ai";

export const iconEnum = (key, { className = "", size = 20 }) => {
  const iconProps = { className, size };

  switch (key) {
    case "user":
      return <AiOutlineUser {...iconProps} />;
    case "account":
      return <AiOutlineSetting {...iconProps} />;
    default:
      return null;
  }
};
